(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["evl-category-banners"] && !Shopify.designMode) return;
  try {
    
  // Run the sliding photos only while the banners are on screen.
  (() => {
    const start = () => {
      document.querySelectorAll('[data-evl-catbanners]').forEach((section) => {
        if (!('IntersectionObserver' in window)) {
          section.classList.add('is-visible');
          return;
        }
        new IntersectionObserver((entries) => {
          entries.forEach((entry) => section.classList.toggle('is-visible', entry.isIntersecting));
        }, { rootMargin: '100px' }).observe(section);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evl-product-row"] && !Shopify.designMode) return;
  try {
    
  // Menu links jump to rows on this same page (/#jackets…): close the mobile drawer so the row is visible.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('header-drawer a[href*="#"]');
    if (!link) return;
    const drawer = link.closest('header-drawer');
    if (drawer && typeof drawer.close === 'function') drawer.close();
  });

  // Shop page: show the pieces in a different random order on every visit.
  const shuffleRows = () => {
    document.querySelectorAll('[data-evl-shuffle] .evl-row__track').forEach((track) => {
      // Random pick each time, but never two pieces of the same line side by side.
      const family = (item) => item.querySelector('.evl-card__title')?.textContent.trim() ?? '';
      const pool = Array.from(track.children);
      const ordered = [];
      while (pool.length) {
        const previous = ordered.length ? family(ordered[ordered.length - 1]) : null;
        const options = pool.filter((item) => family(item) !== previous);
        const choices = options.length ? options : pool;
        const pick = choices[Math.floor(Math.random() * choices.length)];
        ordered.push(pick);
        pool.splice(pool.indexOf(pick), 1);
      }
      ordered.forEach((item) => track.appendChild(item));
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', shuffleRows);
  } else {
    shuffleRows();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
